export enum OverrideReasonType {
  WRONG_SENDER_PRIORITY = 'wrong_sender_priority',
  WRONG_URGENCY = 'wrong_urgency',
  TOPIC_MISMATCH = 'topic_mismatch',
  OTHER = 'other',
}
